import { DataTable } from "@/components/molecules/tables/data-table";
import { useSchedules } from "@/features/calendar/hooks/use-schedules";
import { useTimeOffs } from "@/features/calendar/hooks/use-timeoffs";
import { useTranslation } from "@/features/utils/i18n";
import { PageLayout } from "../layout";
import { useSchedulesColumns } from "./components/schedules/columns";
import { ScheduleDialog } from "./components/schedules/schedule-dialog";
import { TimeOffDialog } from "./components/timeoffs/timeoff-dialog";
import { useTimeOffColumns } from "./components/timeoffs/timeoffs-columns";

export const SchedulesListPage = () => {
  const { t } = useTranslation("schedules");
  const { data: schedules, isLoading: isLoadingSchedules } = useSchedules();
  const { data: timeoffs, isLoading: isLoadingTimeOffs } = useTimeOffs();
  const columns = useSchedulesColumns();
  const timeoffColumns = useTimeOffColumns();

  return (
    <PageLayout title={t("title")} description={t("description")}>
      <div className="space-y-8">
        {/* Schedules Table */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold">
                {t("schedulesSection.title")}
              </h3>
              <p className="text-sm text-muted-foreground">
                {t("schedulesSection.description")}
              </p>
            </div>
            <ScheduleDialog />
          </div>
          <DataTable
            hideSearch
            columns={columns}
            data={schedules || []}
            isLoading={isLoadingSchedules}
          />
        </div>

        {/* Time-offs Table */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold">
                {t("closuresSection.title")}
              </h3>
              <p className="text-sm text-muted-foreground">
                {t("closuresSection.description")}
              </p>
            </div>
            <TimeOffDialog />
          </div>
          <DataTable
            hideSearch
            columns={timeoffColumns}
            data={timeoffs || []}
            isLoading={isLoadingTimeOffs}
          />
        </div>
      </div>
    </PageLayout>
  );
};
